



























































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
// components
import PlayerScreenshotPreview from "@/components/players/modals/PlayerScreenshotPreview.vue";
import vSelect from "vue-select";
// types
import { playerScreenshotsFields } from "@/components/players/fields/playerScreenshotsFields";
import { Player, PlayerActionType, PlayerMultipleActionDto } from "@/services/players/types";
import { Guid } from "guid-typescript";
// service methods
import { getPlayersWithScreenshot, setMultipleAction } from "@/services/players/playerService";
import i18n from "@/i18n";
import { Option } from "@/services/common/types";
import { SolutionTypeEnum } from "@/services/solutions/types";
import { Folder, FolderEntites, FolderOption } from "@/services/folders/types";
import { flatFolderStructure } from "@/services/folders/folderService";
import { SCREENSHOTENDPOINT } from "@/app.config";

@Component({
    components: { PlayerScreenshotPreview, vSelect }
})
export default class PlayerScreenshots extends Vue {
        // local state
        players = [] as Player[];
        fields = playerScreenshotsFields;
        isBusy = false;
        // filter options
        searchQuery = "";
        playerStatus = [{ id: "true", text: i18n.t("player.filterSelectActive") }, { id: "false", text: i18n.t("player.filterSelectInactive") }];
        currentStatus = null as Option | any;
        selectedType = null as Option | any;
        screenshotTimer = 0;
        solutionTypeEnum = SolutionTypeEnum;
        folderEntities = FolderEntites;
        folderOptions = [] as FolderOption[];
        selectedFolder = null as FolderOption | any;
        selectedSubfolderIds = [] as string[];
        selected = "AscendingAlphabetical";
        options = [
            { text: i18n.t("player.ascendingAlphabetical"), value: "AscendingAlphabetical" },
            { text: i18n.t("player.descendingAlphabetical"), value: "DescendingAlphabetical" },
            { text: i18n.t("player.newestToOldest"), value: "NewestToOldest" },
            { text: i18n.t("player.oldestToNewest"), value: "OldestToNewest" },
            { text: i18n.t("player.playerId"), value: "PlayerId" }
        ];

        // lifecycle hooks
        created() {
            this.fetchData();
        }

        destroyed() {
            clearTimeout(this.screenshotTimer);
        }

        // computed
        get filteredData(): Array<Player> {
            const filteredPlayers = this.players.filter(
                x =>
                    (this.searchQuery.length === 0 ||
                        x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                        x.playerId.toString().includes(this.searchQuery)) &&
                    (this.currentStatus !== null ? x.status.toString() === this.currentStatus.id : true) &&
                    (this.selectedType !== null ? (x.solutionType && x.solutionType.toLowerCase() === this.selectedType.id.toLowerCase()) : true) &&
                    (this.selectedFolder !== null ? this.selectedSubfolderIds.includes(x.folderId.toLowerCase()) : true)
            );
            switch (this.selected) {
            case "AscendingAlphabetical": {
                return filteredPlayers.sort((a: Player, b: Player) => {
                    const textA = a.name ? a.name.toUpperCase() : "";
                    const textB = b.name ? b.name.toUpperCase() : "";
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            }
            case "DescendingAlphabetical": {
                return filteredPlayers.sort((a: Player, b: Player) => {
                    const textA = a.name ? a.name.toUpperCase() : "";
                    const textB = b.name ? b.name.toUpperCase() : "";
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }).reverse();
            }
            case "NewestToOldest": {
                return filteredPlayers.sort((a: Player, b: Player) => {
                    // if there is no screenshot for a certain, compare with min date
                    const dateA = a.screenshotTimestamp ? new Date(a.screenshotTimestamp!) : new Date(-8640000000000000);
                    const dateB = b.screenshotTimestamp ? new Date(b.screenshotTimestamp!) : new Date(-8640000000000000);
                    return dateB.getTime() - dateA.getTime();
                });
            }
            case "OldestToNewest": {
                return filteredPlayers.sort((a: Player, b: Player) => {
                    // if there is no screenshot for a certain, compare with min date
                    const dateA = a.screenshotTimestamp ? new Date(a.screenshotTimestamp!) : new Date(-8640000000000000);
                    const dateB = b.screenshotTimestamp ? new Date(b.screenshotTimestamp!) : new Date(-8640000000000000);
                    return dateA.getTime() - dateB.getTime();
                });
            }
            case "PlayerId": {
                return filteredPlayers.sort((a: Player, b: Player) => a.playerId - b.playerId);
            }
            }
            return [];
        }

        // methods
        initTimer() {
            clearTimeout(this.screenshotTimer);
            this.screenshotTimer = setTimeout(this.fetchData, 20000);
        }

        screenshotSrc(playerId: number): string {
            return `${SCREENSHOTENDPOINT}${playerId}?random=${Guid.create().toString()}`;
        }

        fetchData() {
            this.isBusy = true;

            flatFolderStructure(this.folderEntities.Players).then(
                response => {
                    this.folderOptions = response;
                }
            );

            getPlayersWithScreenshot().then(response => {
                this.players = response;
                this.isBusy = false;
                this.initTimer();
                this.$forceUpdate();
            });
        }

        orderMassScreenshot() {
            setMultipleAction({
                actionType: PlayerActionType.screenshot,
                massAction: true
            } as PlayerMultipleActionDto).then(() => {
                this.fetchData();
            });
        }

        previewScreenshot(playerId: number) {
            (this.$refs.playerScreenshotPreviewModal as any).open(playerId);
        }

        timeStampFormatted(date: Date) {
            if (!date) return "";
            const localDate = moment.utc(date).local();
            return `${localDate.format("ll")} ${localDate.format("HH:mm")}`;
        }

        getStatusText(player: Player) {
            if (player.status) return i18n.t("common.online");
            let response = i18n.t("common.offline");
            if (player.lastActiveDate) response += ` ${i18n.t("solution.since")} ${moment.utc(player.lastActiveDate).local().format("dddd")} <br> ${i18n.d(new Date(player.lastActiveDate), "short")} ${moment.utc(player.lastActiveDate).local().format("HH:mm")}`;
            return response;
        }

        formatDate(date: Date) {
            return moment.utc(date).local().format("LLL");
        }

        clearFilter() {
            this.currentStatus = null as Option | any;
            this.selectedType = null as Option | any;
            this.selectedFolder = null as Option | any;
        }

        get solutionTypes() {
            return Object.keys(this.solutionTypeEnum).filter(x => !(parseInt(x) >= 0))
                .map(key => ({ text: i18n.t(`solution.${key}`), id: key }));
        }

        spinnerStatus(player: Player): boolean {
            if (player.lastScreenshotRequestedDate !== null) {
                const lastScreenshotRequestedDate = moment.utc(player.lastScreenshotRequestedDate);
                const screenshotTimestamp = moment.utc(player.screenshotTimestamp!);
                const now = moment.utc(new Date());

                if (screenshotTimestamp > lastScreenshotRequestedDate) return false;

                const duration = moment.duration(now.diff(lastScreenshotRequestedDate));
                const minutes = duration.asMinutes();
                // show spinner up to 2 minutes after a screenshot is requested
                return minutes < 2;
            }
            return false;
        }

        screenshotStatus(player: Player) {
            if (player.lastScreenshotRequestedDate !== null && player.screenshotTimestamp !== null) {
                const lastScreenshotRequestedDate = moment.utc(player.lastScreenshotRequestedDate);
                const screenshotTimestamp = moment.utc(player.screenshotTimestamp);
                return screenshotTimestamp > lastScreenshotRequestedDate;
            }
            return false;
        }

        extractSubfolderIds() {
            if (this.selectedFolder !== null) {
                var parentFolder = this.selectedFolder;
                // get sub folders based on the selected folder's path and extract ids
                const subFoldersMatchingPath = this.folderOptions.filter(folder => folder.path.startsWith(parentFolder.path));
                this.selectedSubfolderIds = subFoldersMatchingPath.map(subfolder => subfolder.id);
            }
        }
}
